import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { fetchCategory } from "@/lib/api";
import { PageHero, Section } from "@/components/Section";
import ProductCard from "@/components/ProductCard";

const cleanCat = (t) => t.split("Manufacturer")[0].split("Hand Tool")[0].trim() || t;

const CategoryDetail = () => {
  const { slug } = useParams();
  const [cat, setCat] = useState(null);
  const [err, setErr] = useState(null);

  useEffect(() => {
    setCat(null);
    fetchCategory(slug).then(setCat).catch((e) => setErr(e?.response?.status || "error"));
  }, [slug]);

  if (err) {
    return (
      <Section>
        <h2 className="font-display text-3xl">Category not found</h2>
        <Link to="/products" className="mt-4 inline-flex jt-btn jt-btn-outline">All Categories</Link>
      </Section>
    );
  }
  if (!cat) return <Section><div className="font-mono text-sm text-[var(--jt-text-muted)]">Loading...</div></Section>;

  return (
    <>
      <PageHero
        eyebrow="Category"
        title={cleanCat(cat.title)}
        intro={cat.meta_description || cat.description?.replace(/<[^>]+>/g, "").slice(0, 220)}
        breadcrumbs={<>Home / <Link to="/products" className="hover:text-white">Products</Link> / <span className="text-white">{cleanCat(cat.title)}</span></>}
      />
      <Section>
        <div className="flex items-end justify-between mb-8">
          <div className="eyebrow">{cat.products?.length || 0} products</div>
          <Link to="/products" className="font-mono text-xs uppercase tracking-widest hover:text-[var(--jt-primary)]">← All Categories</Link>
        </div>
        {cat.products?.length === 0 ? (
          <div className="font-mono text-sm text-[var(--jt-text-muted)]">No products in this category yet.</div>
        ) : (
          <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4" data-testid="category-products">
            {cat.products.map((p) => <ProductCard key={p.slug} p={p} />)}
          </div>
        )}

        {cat.hidden_text ? (
          <div className="mt-16 pt-10 border-t border-[var(--jt-border)] jt-prose max-w-3xl" dangerouslySetInnerHTML={{ __html: cat.hidden_text }} />
        ) : null}
      </Section>
    </>
  );
};

export default CategoryDetail;
